export default {
	loadingContainer: {
		width: '100%',
		height: 'calc(100% - 80px)',
		position: 'absolute',
		backgroundColor: 'black',
		opacity: 0.85,
		zIndex: 1000,
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'row',
		flex: 1,
	},
	loadingContainerForm: {
		height: '100%',
	},
	loadingText: {
		bottom: '23%',
		position: 'relative',
		fontFamily: 'Roboto',
		fontSize: 14,
		fontWeight: 'bold',
		fontStyle: 'normal',
		fontStretch: 'normal',
		lineHeight: 1.36,
		letterSpacing: 'normal',
		textAlign: 'center',
		color: '#ffffff',
	},
	loading: {
		bottom: '22%',
		left: '43%',
		position: 'relative',
	},
	loadingBlock: {
		width: 200,
		marginTop: 25,
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
	},
}
